var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElectricMotorControl({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 5.2,
    cy: 8,
    rx: 4.6,
    ry: 4.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 9.8,
    y1: 8,
    x2: 11.1,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 12.1,
    y1: 8,
    x2: 13.4,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 14.3,
    y1: 8,
    x2: 15.6,
    y2: 8
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3.4,10V6h0.8l0.9,2.8c0.1,0.3,0.1,0.5,0.2,0.6c0-0.1,0.1-0.4,0.2-0.6L6.5,6h0.7V10H6.7V6.7L5.5,10H5.1 L3.9,6.6V10H3.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricMotorControl);
export default __webpack_public_path__ + "static/media/ElectricMotorControl.d2498a8a5141a1171e8c47e71f2b9f5c.svg";
export { ForwardRef as ReactComponent };